export default {
  guide: {
    label: '新手指引',
    tips: '可在此处查看新手指引哦～',
    title: '欢迎来到 Playturbo！',
    content:
      '这是一个强大且易用的创作平台，首先，让我来为你介绍它的核心功能，帮助你快速上手。',
    startButton: '开始探索',
    nextButton: '下一步',
    preButton: '上一步',
    complete: '完成',
    step1: {
      label: '可玩工具',
      describe: {
        title: '提供三种制作方式：',
        content1:
          '可玩模板：利用换肤编辑器，在可玩模板的基础上替换资源，调整参数，快速导出高质量可玩广告。',
        content2: {
          title: '自由编辑器：',
          describe1:
            '从零开始制作：用户可以从空白画布开始，像制作PPT一样自由创建可玩素材，完全自定义设计内容，以满足各种创意需求。',
          describe2:
            '模板基础编辑：支持在现有的可玩模板上进行元素布局和编辑，用户可以更加灵活地修改和调整可玩素材，实现个性化定制。',
        },
        content3: '视频转可玩：将普通视频转化为交互视频，快速实现互动效果。',
      },
    },
    step2: {
      label: '视频工具',
      describe: {
        title: '提供两种制作方式：',
        content1:
          '视频布局模板：专注于视频尺寸和多语言的快速裂变，尤其适用于批量内容生成。',
        content2:
          '视频编辑器：提供更精细的创意调整功能，拥有灵活的编辑能力，帮助实现创意迭代和动态优化。',
      },
    },
    step3: {
      label: '图片工具',
      describe: {
        title:
          '即链接生图，用于批量生成图片创意。只需要填入产品链接，系统将自动获取产品信息和参考样本，海量图片创意一键生成。',
      },
    },
    step4: {
      label: '查看 Demo 项目',
      describe: {
        title:
          '每个工具模块我们都提供了 Demo 项目和帮助中心教学文档，方便您快速上手，选择您感兴趣的 Demo 项目查看吧！',
      },
    },
  },
}
